/* Blanks collection UI, matched to sell.dtftransfers.com.
 *
 * Three additions the stock theme markup does not provide. Everything else is CSS in
 * assets/blanks-collection-ui.css. Loaded only from the blanks collection header section.
 *
 *  1. Counts right-aligned. The theme renders "In stock (1101)" as a bare text node inside the
 *     label, so there is nothing to align against. This lifts the trailing "(N)" into its own
 *     span.
 *  2. A filter search box that narrows the filter OPTIONS (never the products, and never the
 *     open/closed state of a group).
 *  3. A toolbar above the grid with the product count on the left and sort on the right. The
 *     real sort select stays inside the facets form (moving it out would break the theme's
 *     change handler, which is bound to the form), so the toolbar renders a proxy select that
 *     writes back to the original and dispatches its change event.
 *
 * All of it re-runs after the theme replaces the grid on filter or sort, which it does through
 * the Section Rendering API rather than a page load.
 */
(function () {
  'use strict';
  if (window.__blanksCollectionUI) return;
  window.__blanksCollectionUI = true;

  var SIDEBAR = '.facets-sidebar';
  var COUNT_RE = /\s*\((\d[\d,]*)\)\s*$/;

  function scope() {
    return document.querySelector(SIDEBAR) ? document.body : null;
  }

  /* 1. counts ------------------------------------------------------------- */
  function splitCounts(root) {
    var labels = (root || document).querySelectorAll('.facet-checkbox');
    for (var i = 0; i < labels.length; i++) {
      var label = labels[i];
      if (label.querySelector('.bcu-n')) continue;
      var node = null;
      for (var j = label.childNodes.length - 1; j >= 0; j--) {
        var n = label.childNodes[j];
        if (n.nodeType === 3 && COUNT_RE.test(n.nodeValue)) { node = n; break; }
      }
      if (!node) continue;
      var m = node.nodeValue.match(COUNT_RE);
      node.nodeValue = node.nodeValue.replace(COUNT_RE, '');
      var span = document.createElement('span');
      span.className = 'bcu-n';
      span.textContent = m[1];
      label.appendChild(span);
    }
  }

  /* 1b. card colour swatches ---------------------------------------------- */
  /* Rendered by snippets/product-item.liquid as colour NAMES, because Collective carries no
     swatch metafields. assets/blanks-swatch-colors.js publishes the same name-to-hex table the
     PDP uses, so the cards and the product page can never disagree. */
  function paintSwatches(root) {
    var map = window.NT_BLANK_COLORS;
    if (!map) return false;
    var sw = (root || document).querySelectorAll('.bcu-sw[data-colorname]:not([data-bcu-painted])');
    for (var i = 0; i < sw.length; i++) {
      var el = sw[i];
      var name = String(el.getAttribute('data-colorname') || '').trim().toUpperCase().replace(/\s+/g, ' ');
      var hex = map[name];
      if (!hex) {
        var alt = name.indexOf('GRAY') > -1 ? name.replace(/GRAY/g, 'GREY')
                : (name.indexOf('GREY') > -1 ? name.replace(/GREY/g, 'GRAY') : null);
        if (alt) hex = map[alt];
      }
      if (hex) el.style.backgroundColor = hex;
      el.setAttribute('data-bcu-painted', '1');
    }
    return true;
  }

  /* 1b-ii. colour chips on the Colors facet ------------------------------- */
  /* The facet values are broad families (Black, Blue, Brown, Grey, ...), not the catalogue's
     specific colour names, so the shared name-to-hex table covers most of them but not all.
     FAMILY fills the gaps rather than leaving a blank chip. */
  var FAMILY = {
    BLACK: '#101011', WHITE: '#ffffff', GREY: '#9aa0a6', GRAY: '#9aa0a6', SILVER: '#c7ccd1',
    BLUE: '#1d4f91', NAVY: '#1b2a4a', RED: '#c0334a', ORANGE: '#f4762a', YELLOW: '#f2c744',
    GREEN: '#2e7d4f', PURPLE: '#5b3a8c', PINK: '#e06a96', BROWN: '#5b3a29', BEIGE: '#d8cbb6',
    TAN: '#c9a87c', GOLD: '#d4a437', CAMO: '#6b6f47', MAROON: '#6f2233', TEAL: '#1f7a8c',
    CHARCOAL: '#4a4f57', KHAKI: '#c3b091', CREAM: '#f3ead6', IVORY: '#f4f0e4', MULTI: '#9aa0a6'
  };

  function facetColorHex(label) {
    var n = String(label || '').trim().toUpperCase().replace(/\s+/g, ' ');
    var map = window.NT_BLANK_COLORS;
    if (map && map[n]) return map[n];
    if (FAMILY[n]) return FAMILY[n];
    var first = n.split(/[ /]/)[0];
    return FAMILY[first] || (map && map[first]) || null;
  }

  function paintFacetColors() {
    var inputs = document.querySelectorAll(SIDEBAR + ' input[name="filter.p.m.custom.facet_colors"]');
    for (var i = 0; i < inputs.length; i++) {
      var label = inputs[i].closest('.facet-checkbox');
      if (!label || label.querySelector('.bcu-fsw')) continue;
      var text = label.textContent.replace(/\s*\d[\d,]*\s*$/, '').trim();
      var hex = facetColorHex(text);
      var chip = document.createElement('span');
      chip.className = 'bcu-fsw';
      if (hex) chip.style.backgroundColor = hex;
      else chip.classList.add('bcu-fsw--unknown');
      inputs[i].insertAdjacentElement('afterend', chip);
    }
  }

  /* 1d. colour-matched card images --------------------------------------- */
  /* With a Colors filter active, the grid otherwise shows each product in whatever colour its
     featured image happens to be, so filtering to Black returns a wall of blue and grey shirts.
     This swaps each card to a variant image in the filtered colour. Variant data only exists in
     /products/<handle>.js, so cards are fetched lazily as they scroll into view and the result
     is cached per handle. No colour filter, no fetches at all. (Justin 2026-09-21) */
  var pcache = {};

  function activeColorFamilies() {
    var out = [];
    try {
      new URL(window.location.href).searchParams.forEach(function (v, k) {
        if (k === 'filter.p.m.custom.facet_colors') out.push(String(v).toLowerCase());
      });
    } catch (e) {}
    return out;
  }

  function variantForFamilies(p, fams) {
    var names = (p.options || []).map(function (o) {
      return String((o && o.name) || o || '').toLowerCase();
    });
    var ci = -1;
    for (var i = 0; i < names.length; i++) if (/colou?r/.test(names[i])) { ci = i; break; }
    if (ci < 0) return null;

    var fallback = null;
    for (var j = 0; j < p.variants.length; j++) {
      var v = p.variants[j];
      var c = String(v['option' + (ci + 1)] || '').toLowerCase();
      if (!c || !v.featured_image || !v.featured_image.src) continue;
      for (var k = 0; k < fams.length; k++) {
        if (c === fams[k] || c.indexOf(fams[k]) > -1) {
          if (v.available) return v;      /* prefer one that can actually be bought */
          if (!fallback) fallback = v;
        }
      }
    }
    return fallback;
  }

  function swapCardImage(card, fams) {
    var a = card.querySelector('a[href*="/products/"]');
    var img = card.querySelector('.product-item__image-figure img, img.img');
    if (!a || !img) return;
    var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    if (!m) return;
    var handle = m[1];

    function apply(p) {
      if (!p) return;
      var v = variantForFamilies(p, fams);
      if (!v) return;
      img.removeAttribute('srcset');
      img.removeAttribute('data-srcset');
      img.src = v.featured_image.src;
    }

    if (pcache[handle]) { apply(pcache[handle]); return; }
    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (p) { pcache[handle] = p; apply(p); } })
      .catch(function () {});
  }

  function colorMatchImages() {
    var fams = activeColorFamilies();
    if (!fams.length) return;
    var cards = document.querySelectorAll('.product-item:not([data-bcu-img])');
    if (!cards.length) return;

    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < cards.length; i++) {
        cards[i].setAttribute('data-bcu-img', '1');
        swapCardImage(cards[i], fams);
      }
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        obs.unobserve(en.target);
        swapCardImage(en.target, fams);
      });
    }, { rootMargin: '300px 0px' });
    for (var j = 0; j < cards.length; j++) {
      cards[j].setAttribute('data-bcu-img', '1');
      io.observe(cards[j]);
    }
  }

  /* 1e. collapsible filter groups ----------------------------------------- */
  /* Closed by default, as the NOD sidebar reads: with thirteen facets the open list ran past
     3,000px and buried everything below Brand.
     Selecting a filter makes the theme re-render the whole facets form, so this re-initialises
     against fresh markup every time. Two things that has to get right:
       - A group is only marked done once it is actually wired. Marking it while the re-render
         was still in flight left groups permanently expanded, which is why choosing one filter
         appeared to open all the others.
       - Open/closed is remembered by group name across re-renders, so applying a filter does
         not collapse the group you are working in. (Justin 2026-09-21) */
  var accOpen = {};

  function makeCollapsible() {
    var groups = document.querySelectorAll(SIDEBAR + ' .facets__disclosure');
    for (var i = 0; i < groups.length; i++) {
      (function (group) {
        var head = group.querySelector('.facets__summary-text');
        if (!head) return;
        /* The marker lives on the HEAD. Applying a filter re-renders the facets through the
           Section Rendering API: the .facets__disclosure elements survive but their summaries
           are replaced, so a marker on the group made this skip re-wiring and every group was
           left expanded, caretless and unclickable. A new head has no marker, so it re-wires.
           (Justin 2026-09-22) */
        if (head.hasAttribute('data-bcu-head')) return;
        var body = [];
        for (var c = 0; c < group.children.length; c++) {
          if (group.children[c] !== head) body.push(group.children[c]);
        }
        /* not rendered yet: leave it unmarked so the next pass can wire it */
        if (!body.length) return;

        head.setAttribute('data-bcu-head', '1');
        group.setAttribute('data-bcu-acc', '1');
        group.classList.add('bcu-acc');
        head.classList.add('bcu-acc__head');
        head.setAttribute('role', 'button');
        head.setAttribute('tabindex', '0');

        var name = head.textContent.replace(/\s+/g, ' ').trim();
        var checked = !!group.querySelector('input:checked');

        function setOpen(open) {
          accOpen[name] = open;
          group.classList.toggle('is-open', open);
          head.setAttribute('aria-expanded', open ? 'true' : 'false');
          for (var b = 0; b < body.length; b++) body[b].style.display = open ? '' : 'none';
        }
        function toggle() { setOpen(!group.classList.contains('is-open')); }

        setOpen(accOpen[name] === true || checked);

        head.addEventListener('click', toggle);
        head.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
        });
      }(groups[i]));
    }
  }

  /* 2. product search ----------------------------------------------------- */
  /* Searches the blanks CATALOGUE, the way the NOD sidebar box does: typing g500 returns G500,
     G500B, G500L and G500VL.
     Matching happens server side through templates/search.blanksjson.liquid, reached as
     /search?q=<term>*&type=product&view=blanksjson. The trailing * is what makes g500 a prefix,
     which is the bit plain predictive search gets wrong (it returns G500 alone). One query is
     ~270 ms and a few KB, and the view hands back exactly the six fields a card draws, so the
     cards carry the same swatch row, brand and price as the Liquid-rendered ones and quick buy
     decorates them through data-bqb-handle.

     The client-side catalogue below is now only a fallback for when that view is missing or
     errors. It is the old primary path and it cost ~35 MB over 5 sequential requests (every
     blank carries ~96 variants and products.json has no field selection), which is why a search
     used to take about ten seconds. Nothing loads unless the fast path fails.
     (Justin 2026-09-22) */
  var catalogue = null, catalogueLoading = null, gridSnapshot = null;

  function collectionHandle() {
    var m = window.location.pathname.match(/\/collections\/([^/?#]+)/);
    return m ? m[1] : 'blanks';
  }

  function loadCatalogue() {
    if (catalogue) return Promise.resolve(catalogue);
    if (catalogueLoading) return catalogueLoading;
    var handle = collectionHandle();
    var all = [];
    function page(n) {
      return fetch('/collections/' + handle + '/products.json?limit=250&page=' + n, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          var ps = (d && d.products) || [];
          all = all.concat(ps);
          if (ps.length === 250 && n < 8) return page(n + 1);
          catalogue = all;
          return all;
        });
    }
    catalogueLoading = page(1).catch(function () { catalogue = []; return []; });
    return catalogueLoading;
  }

  /* brand names come from the Brand facet, so a title can be labelled without another lookup */
  function brandList() {
    var out = [];
    var inputs = document.querySelectorAll(SIDEBAR + ' input[name="filter.p.m.custom.facet_brand"]');
    for (var i = 0; i < inputs.length; i++) {
      var label = inputs[i].closest('.facet-checkbox');
      if (label) out.push(label.textContent.replace(/\s*\d[\d,]*\s*$/, '').trim());
    }
    return out.sort(function (a, b) { return b.length - a.length; });
  }

  function brandFor(title, brands) {
    var t = String(title || '').toLowerCase();
    for (var i = 0; i < brands.length; i++) {
      if (brands[i] && t.indexOf(brands[i].toLowerCase()) === 0) return brands[i];
    }
    return '';
  }

  function money(v) {
    var n = parseFloat(v);
    return isNaN(n) ? '' : '$' + n.toFixed(2);
  }

  function colorsOfProduct(p) {
    var idx = -1;
    (p.options || []).forEach(function (o, i) {
      var name = String((o && o.name) || o || '').toLowerCase();
      if (/colou?r/.test(name)) idx = i;
    });
    if (idx < 0) return [];
    var seen = {}, out = [];
    (p.variants || []).forEach(function (v) {
      var c = v['option' + (idx + 1)];
      if (c && !seen[c]) { seen[c] = 1; out.push(c); }
    });
    return out;
  }

  /* both paths normalise to the same item shape, so resultCard has one input to draw */
  function fromView(rows) {
    return rows.map(function (r) {
      return {
        handle: r.h,
        title: r.t,
        image: r.i || '',
        low: typeof r.p === 'number' ? r.p / 100 : null,
        brand: r.b || '',
        colors: r.c || [],
        colorCount: typeof r.n === 'number' ? r.n : (r.c || []).length,
        cols: r.k || []
      };
    });
  }

  function fromCatalogue(ps) {
    return ps.map(function (p) {
      var first = (p.images && p.images[0]) || null;
      var img = (first && (first.src || first)) || '';
      var prices = (p.variants || []).map(function (v) { return parseFloat(v.price); })
        .filter(function (n) { return !isNaN(n); });
      var colors = colorsOfProduct(p);
      return {
        handle: p.handle,
        title: p.title,
        image: typeof img === 'string' ? img : '',
        low: prices.length ? Math.min.apply(null, prices) : null,
        brand: '',
        colors: colors.slice(0, 8),
        /* the fallback reads /collections/<handle>/products.json, which is already scoped to the
           collection being viewed, so it needs no membership list and must not be filtered by one */
        colorCount: colors.length,
        cols: null
      };
    });
  }

  function resultCard(p, brands) {
    var img = p.image || '';
    if (img && img.indexOf('?') < 0) img += '?width=480';
    var low = p.low;
    var colors = p.colors || [];
    var total = p.colorCount || colors.length;
    var chips = colors.slice(0, 5).map(function (c) {
      return '<span class="bcu-sw" data-colorname="' + String(c).replace(/"/g, '&quot;') + '"></span>';
    }).join('');
    if (total > 5) chips += '<span class="bcu-sw-more">+' + (total - 5) + '</span>';
    var brand = p.brand || brandFor(p.title, brands);

    var el = document.createElement('div');
    /* Plain markup, not the theme's lazy-image classes: those keep the photo hidden until the
       theme's own lazy loader adds lazyloaded/revealed, which never runs on nodes injected after
       page load, so search results rendered as empty cards. product-item stays for the card
       chrome and so quick buy decorates it. (Justin 2026-09-22) */
    el.className = 'product-item bcu-rcard';
    el.setAttribute('data-bqb-handle', p.handle);
    /* same class names as the Liquid cards, so one set of grid rules lays both out: swatches,
       then the price with the brand beside it, then the title. (Justin 2026-09-22) */
    el.innerHTML =
      '<a class="product-item__image bcu-rcard__img" href="/products/' + p.handle + '">' +
        (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
      '</a>' +
      '<div class="product-item__text bcu-rcard__body">' +
        (chips ? '<div class="bcu-sw-row" aria-hidden="true">' + chips + '</div>' : '') +
        (brand ? '<span class="bcu-brand"></span>' : '') +
        (low !== null ? '<div class="product-item__price"><span class="bcu-price">' +
          '<span class="bcu-price__label">As low as</span>' +
          '<span class="bcu-price__amt">' + money(low) + '</span></span></div>' : '') +
        '<a class="product-item__title bcu-rcard__title" href="/products/' + p.handle + '">' +
          '<span></span></a>' +
      '</div>';
    if (brand) el.querySelector('.bcu-brand').textContent = brand;
    el.querySelector('.bcu-rcard__title span').textContent = p.title;
    return el;
  }

  function renderResults(matches, elsewhere) {
    var g = grid();
    if (!g) return;
    if (gridSnapshot === null) gridSnapshot = g.innerHTML;
    var brands = brandList();
    g.innerHTML = '';
    if (!matches.length && elsewhere) {
      var here = (document.querySelector('.bch-h1') || {}).textContent || 'this category';
      var note = document.createElement('div');
      note.className = 'bcu-noneheres';
      note.innerHTML = '<p></p><button type="button" class="bcu-showall"></button>';
      note.querySelector('p').textContent =
        'Nothing in ' + here.trim() + ' matches that. ' + elsewhere +
        (elsewhere === 1 ? ' match' : ' matches') + ' in all blank apparel.';
      note.querySelector('.bcu-showall').textContent = 'Show all blank apparel matches';
      g.appendChild(note);
    }
    matches.slice(0, 200).forEach(function (p) {
      try { g.appendChild(resultCard(p, brands)); } catch (e) {}
    });
    var countEl = document.querySelector('.bcu-toolbar__count');
    if (countEl) countEl.textContent = matches.length + (matches.length === 1 ? ' product' : ' products');
    paintSwatches(g);
    if (window.NTBlanksQuickBuy) window.NTBlanksQuickBuy.decorate(g);
  }

  function restoreGrid() {
    var g = grid();
    if (!g || gridSnapshot === null) return;
    g.innerHTML = gridSnapshot;
    gridSnapshot = null;
    var src = document.querySelector('.collection-product-count');
    var countEl = document.querySelector('.bcu-toolbar__count');
    if (countEl && src) {
      var m = src.textContent.match(/(\d[\d,]*)/);
      countEl.textContent = m ? m[1] + ' products' : src.textContent.trim();
    }
    paintSwatches(g);
    if (window.NTBlanksQuickBuy) window.NTBlanksQuickBuy.decorate(g);
  }

  /* The theme re-renders the facets form on filter changes, and the re-render carries the
     injected input across WITHOUT its listener (the node survives, the binding does not). That
     is why typing did nothing while a synthetic event on a freshly bound input worked. A single
     delegated listener on document cannot be detached by any re-render. (Justin 2026-09-22) */
  var searchTimer = null, searchSeq = 0;

  var VIEW_MAX_PAGES = 4;

  function searchPage(q, n) {
    return fetch('/search?type=product&view=blanksjson&page=' + n + '&q=' + encodeURIComponent(q),
      { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('view'); return r.text(); })
      .then(function (t) {
        var d = JSON.parse(t);
        if (!d || !Array.isArray(d.items)) throw new Error('shape');
        return d;
      });
  }

  function searchView(raw) {
    var q = raw.replace(/\*+$/, '') + '*';
    return searchPage(q, 1).then(function (first) {
      var pages = Math.min(first.pages || 1, VIEW_MAX_PAGES);
      if (pages < 2) return fromView(first.items);
      /* the view paginates at 50, which is Liquid's ceiling, and a brand-wide term overflows it.
         The rest come in one parallel burst rather than a page at a time. A page that fails is
         dropped rather than failing the whole search. */
      var rest = [];
      for (var n = 2; n <= pages; n++) {
        rest.push(searchPage(q, n).catch(function () { return { items: [] }; }));
      }
      return Promise.all(rest).then(function (ds) {
        var items = first.items;
        for (var i = 0; i < ds.length; i++) items = items.concat(ds[i].items);
        return fromView(items);
      });
    });
  }

  function searchCatalogue(raw) {
    var q = raw.toLowerCase().replace(/\s+/g, '');
    return loadCatalogue().then(function (ps) {
      return fromCatalogue(ps.filter(function (p) {
        var hay = (String(p.title) + ' ' + String(p.handle)).toLowerCase().replace(/\s+/g, '');
        return hay.indexOf(q) > -1;
      }));
    });
  }

  /* On a category page the results belong to that category. Storefront search has no collection
     scope, so the view reports each product's blank collections and the filtering happens here.
     When a term matches nothing in the category but does match elsewhere, the shopper is told so
     and offered the wider list rather than being left at an empty grid. (Justin 2026-09-22) */
  function scopeHandle() {
    var h = collectionHandle();
    return h && h !== 'blanks' ? h : null;
  }

  var lastAll = null;

  function runSearch(value) {
    var raw = String(value || '').trim();
    if (raw.replace(/\s+/g, '').length < 2) { restoreGrid(); return; }
    var seq = ++searchSeq;
    searchView(raw)
      .catch(function () { return searchCatalogue(raw); })
      /* a slow answer to an earlier keystroke must not overwrite a newer one */
      .then(function (items) {
        if (seq !== searchSeq) return;
        lastAll = items;
        var h = scopeHandle();
        if (!h) { renderResults(items); return; }
        var inCat = items.filter(function (p) { return !p.cols || p.cols.indexOf(h) > -1; });
        renderResults(inCat, inCat.length === 0 ? items.length : 0);
      })
      .catch(function () {});
  }

  /* Capture phase, not bubble: the facets form stops input events propagating (it would
     otherwise auto-submit on every keystroke), so a bubbling document listener never fired.
     Capture runs before the target, so nothing downstream can suppress it. (Justin 2026-09-22) */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.classList || !e.target.classList.contains('bcu-showall')) return;
    if (lastAll) renderResults(lastAll);
  });

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains('bcu-search')) return;
    if (searchTimer) clearTimeout(searchTimer);
    var v = t.value;
    searchTimer = setTimeout(function () { runSearch(v); }, 220);
  }, true);

  /* Lives in the toolbar above the grid, at the left, with the count and sort at the right.
     Never inside <facet-filters-form>: that element submits the facets form on input, and the
     reply swaps the whole product grid ELEMENT through the Section Rendering API. While the box
     downloaded the catalogue the theme's swap always landed first and our results painted over
     it; now that a query answers in ~300 ms the swap landed last and wiped them a second after
     they appeared. Out here nothing listens, and the box also survives a filter re-render with
     whatever is typed in it. (Justin 2026-09-22) */
  function addSearch() {
    var bar = document.querySelector('.bcu-toolbar');
    if (!bar || bar.querySelector('.bcu-search')) return;
    var input = document.createElement('input');
    input.type = 'search';
    input.className = 'bcu-search';
    input.placeholder = 'Search blanks...';
    input.setAttribute('aria-label', 'Search blank apparel');
    bar.insertBefore(input, bar.firstChild);
    /* The header search bar lands here as /collections/blanks?q=<term>: start with the box filled
       and the results showing, as the shopper typed them up top. Once, when the box is created.
       (Justin 2026-09-23) */
    var q = '';
    try { q = new URLSearchParams(window.location.search).get('q') || ''; } catch (err) {}
    if (q.trim()) {
      input.value = q;
      setTimeout(function () { runSearch(q); }, 0);
    }
  }

  /* 3. toolbar ------------------------------------------------------------ */
  function grid() {
    return document.querySelector('.collection.grid');
  }

  function buildToolbar() {
    var g = grid();
    var realSort = document.querySelector(SIDEBAR + ' select[name="sort_by"]');
    if (!g) return;

    var bar = document.querySelector('.bcu-toolbar');
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'bcu-toolbar';
      bar.innerHTML = '<span class="bcu-toolbar__count"></span>';
      g.parentNode.insertBefore(bar, g);
    }

    /* count, read from whatever the theme rendered */
    var src = document.querySelector('.collection-product-count');
    var countEl = bar.querySelector('.bcu-toolbar__count');
    /* a live search owns the count; the observer re-runs this on every DOM change and would
       otherwise stamp the collection total back over the result count */
    if (countEl && gridSnapshot === null) {
      var text = src ? src.textContent.replace(/\s+/g, ' ').trim() : '';
      var m = text.match(/(\d[\d,]*)/);
      countEl.textContent = m ? m[1] + ' products' : text;
    }

    if (!realSort) return;
    var wrap = bar.querySelector('.bcu-toolbar__sort');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'bcu-toolbar__sort';
      var proxy = document.createElement('select');
      proxy.setAttribute('aria-label', 'Sort by');
      wrap.appendChild(proxy);
      bar.appendChild(wrap);
      /* Writing to the hidden original and dispatching change did not take: the theme's handler
         is bound to the visible control. Sorting is a plain query param, so navigate instead,
         which also keeps the sort in the URL and therefore shareable and back-button safe. */
      proxy.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', proxy.value);
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      });
    }
    var proxySel = wrap.querySelector('select');
    if (proxySel.options.length !== realSort.options.length) {
      proxySel.innerHTML = realSort.innerHTML;
    }
    var current = new URL(window.location.href).searchParams.get('sort_by');
    proxySel.value = current || realSort.value;
  }

  /* Mobile filter drawer: the theme applies each filter as it is ticked (it re-renders the grid
     behind the drawer), but the drawer had only a close X, so nothing said "done". This pins an
     Apply filters button to the drawer's foot that closes it and brings the results into view.
     It sits outside the facets form, which the theme replaces on every change, so it stays put.
     (Justin 2026-09-23) */
  function addApplyButton() {
    var d = document.getElementById('site-filters-sidebar');
    if (!d || d.querySelector('.bcu-apply')) return;
    var bar = document.createElement('div');
    bar.className = 'bcu-apply';
    bar.innerHTML = '<button type="button" class="button button--solid button--fullwidth bcu-apply__btn">Apply filters</button>';
    d.appendChild(bar);
    bar.querySelector('button').addEventListener('click', function () {
      var x = d.querySelector('.sidebar__close');
      if (x) x.click();
      var top = document.querySelector('.bcu-toolbar') || document.querySelector('.collection');
      if (!top) return;
      var hd = document.querySelector('.dtfhd') || document.querySelector('header');
      var off = (hd ? hd.getBoundingClientRect().height : 70) + 12;
      window.scrollTo({ top: Math.max(0, top.getBoundingClientRect().top + window.scrollY - off), behavior: 'smooth' });
    });
  }

  function run() {
    if (!scope()) return;
    document.body.classList.add('bcu-scope');
    /* the colour table is a deferred script, so retry briefly if it has not evaluated yet */
    if (!paintSwatches() && !run._retry) {
      run._retry = true;
      setTimeout(function () { run._retry = false; paintSwatches(); }, 300);
    }
    splitCounts();
    paintFacetColors();
    makeCollapsible();
    colorMatchImages();
    buildToolbar();
    addSearch();
    addApplyButton();
    /* the same re-render swaps the product grid, and quick buy's own observer misses it */
    if (window.NTBlanksQuickBuy) window.NTBlanksQuickBuy.decorate();
  }

  function start() {
    run();
    /* the theme swaps the grid and the facet list in place when a filter or sort changes */
    if ('MutationObserver' in window) {
      var target = document.querySelector('#main, main, body');
      if (target) {
        var pending = null;
        new MutationObserver(function () {
          if (pending) clearTimeout(pending);
          pending = setTimeout(run, 120);
        }).observe(target, { childList: true, subtree: true });
      }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
}());
